// Directly reuse xandr-campaign/src/model/ad-group-criterions.js
import _ from 'underscore';
import { readAdGroupCriterions } from '@bingads-webui-campaign-react/xandr-campaign';

// TODO: remove later. Just a temp placeholder
export {
  viewModelToBulkModelForTargeting,
  initialAdGroupCriterionsViewModel,
  modelToViewModelForAdGroupCriterions,
  modelToViewModelForLocationTargets,
  modelToViewModelForDayTimeTargets,
  modelToViewModelForTargetCriterions,
  modelToViewModelForAudienceCriterions,
  bulkModelToViewModelForDayTimeTargets,
  bulkModelToViewModelForLocationTargets,
  viewModelToBulkModelForLocationTargets,
  viewModelToBulkModelForAdSchedules,
  viewModelToBulkModelForAudiences,
  loadBundleCountries,
  readAdGroupCriterions,
  readLocationCriterions as readAdGroupLocationCriterions,
  readDayTimeCriterions,
  readTargetingCriterions as readAdGroupTargetingCriterions,
  readAudienceCriterions,
} from '@bingads-webui-campaign-react/xandr-campaign';

// Reuse display-plus-campaigns/src/shared/model/adgroup-criterions-with-bid-adjustment.js
export {
  viewModelToBulkModelForBidAdjustmentUI,
} from '@bingads-webui-campaign-react/display-plus-campaigns';

export const readAdGroupAgeAndGenderCriterions = ({
  cid,
  aid,
  campaignId,
  adGroupId,
}) => readAdGroupCriterions({
  cid,
  aid,
  campaignId,
  adGroupId,
  type: "isof(Criterion,'Model.AgeCriterion') or isof(Criterion,'Model.GenderCriterion')",
});

export const bulkModelToViewModelForProductPartitions = ({
  adGroupModel,
}) => adGroupModel.ProductPartitions && ({
  ProductPartitions: adGroupModel.ProductPartitions.map(productPartition => _.omit(productPartition, 'Client Id')),
});
